<div class="review-deal-funding" (click)="showReviewModal()">
	<div class="flag" *ngIf="showFlag"></div>
</div>
